import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Item = function Item(_ref) {
  var href = _ref.href,
      lang = _ref.lang,
      title = _ref.title;
  var getClassName = getClassNameFactory("LanguageSwitcherItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    lang: lang,
    className: getClassName({
      descendantName: "link"
    })
  }, title));
};

Item.displayName = "LanguageSwitcher.Item";
export default Item;